import React from "react";
import { Mutation, MutationProps, MutationFn } from "react-apollo";

import { transformMutationData } from "../helpers";
import { formSubmit } from "../formSubmit";

export interface MutationArgs {
  form: string;
}

class BaseMutation extends Mutation<{}, MutationArgs> {}

type FormSubmitMutationProps = Pick<MutationProps<{}, MutationArgs>, "children">;

export type MutationFunction = MutationFn<{}, MutationArgs>;

export const FormSubmitMutation: React.FC<FormSubmitMutationProps> = ({ children, ...props }) => (
  <BaseMutation {...props} mutation={formSubmit}>
    {(mutateFn, data) => children(transformMutationData(mutateFn), data)}
  </BaseMutation>
);
